import constants from './../../constants'

const formatQuantityDaysToDueDate = email => {
  if (email.entity !== 'invoice') {
    return ''
  }

  if (
    constants.emails.BEFORE_DUE_DATE_ACTION_METHODS.includes(
      email.actionMethod,
    )
  ) {
    return 'Dias antes do vencimento'
  }

  if (
    constants.emails.AFTER_DUE_DATE_ACTION_METHODS.includes(email.actionMethod)
  ) {
    return 'Dias depois do vencimento'
  }

  return ''
}

export default formatQuantityDaysToDueDate
